import Vue from 'vue'
import Vuex from 'vuex'

//首页暂时用作测试
import apply from './modules/apply'


Vue.use(Vuex)

const store = {
  state:{
    openid:localStorage.getItem('openid'),
    hasBinded:localStorage.getItem('hasBinded'),
    uuid:localStorage.getItem('uuid'),
    patientId:localStorage.getItem('patientId'),
    patientUUID:localStorage.getItem('patientUUID'),
    // orderNo: localStorage.getItem('orderNo'),
    orderFee:1,
    orderApplySuccess:false,
  },
  actions:{
  },
  mutations:{
    set_user_id(state,data){
      state.patientId = data.patientId;
      state.patientUUID = data.patientUUID;
    },
    set_order_status(state,data){
      state.orderApplySuccess = data;
    },
  },
  modules:{
    apply
  }
}


export default store



// WEBPACK FOOTER //
// ./src/store/index.js